import { render, staticRenderFns } from "./LinkButtonBlock.vue?vue&type=template&id=49760b27&"
import script from "./LinkButtonBlock.vue?vue&type=script&lang=js&"
export * from "./LinkButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./LinkButtonBlock.vue?vue&type=style&index=0&id=49760b27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports